// src/components/SmileSection.js
import React, { useEffect, useRef, useState } from 'react';

const SmileSection = () => {

    return (

  <div className="WordSection1 container">
    <p className="MsoNormal">
      <span lang="EN-GB">&nbsp;</span>
    </p>
    <p className="MsoNormal">
      <span lang="EN-GB">
        Our website uses cookies to distinguish you from other users of our
        website. This helps us to provide you with a good experience when you
        browse our website and also allows us to improve our site.&nbsp;
        <br />
        <br />
        A cookie is a small file of letters and numbers that we store on your
        browser or the hard drive of your computer if you agree. Cookies contain
        information that is transferred to your computer's hard drive.&nbsp;
        <br />
        <br />
        We use the following cookies:
      </span>
    </p>
    <ul style={{ marginTop: "0cm" }} type="disc">
      <li className="MsoNormal">
        <span lang="EN-GB">
          Strictly necessary cookies. These are cookies that are required for
          the operation of our website. They include, for example, cookies that
          enable you to log into secure areas of our website.
        </span>
      </li>
    </ul>
    <p className="MsoNormal">
      <span lang="EN-GB">
        <br />
        You can find more information about the individual cookies we use and
        the purposes for which we use them in the table below:&nbsp;
      </span>
    </p>
    <table
      className="MsoNormalTable"
      border={0}
      cellSpacing={0}
      cellPadding={0}
      width={1110}
      style={{ width: "832.5pt", borderCollapse: "collapse" }}
    >
      <thead>
        <tr>
          <td
            valign="bottom"
            style={{
              border: "solid #DEE2E6 1.0pt",
              borderBottom: "solid #DEE2E6 1.5pt",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <b>
                <span lang="EN-GB">
                  Cookie Title&nbsp;
                  <br />
                  <br />
                  Cookie Name
                </span>
              </b>
            </p>
          </td>
          <td
            valign="bottom"
            style={{
              borderTop: "solid #DEE2E6 1.0pt",
              borderLeft: "none",
              borderBottom: "solid #DEE2E6 1.5pt",
              borderRight: "solid #DEE2E6 1.0pt",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <b>
                <span lang="EN-GB">Purpose</span>
              </b>
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            valign="top"
            style={{
              border: "solid #DEE2E6 1.0pt",
              borderTop: "none",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <span lang="EN-GB">laravel_session</span>
            </p>
          </td>
          <td
            valign="top"
            style={{
              borderTop: "none",
              borderLeft: "none",
              borderBottom: "solid #DEE2E6 1.0pt",
              borderRight: "solid #DEE2E6 1.0pt",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <span lang="EN-GB">
                To identify a session instance for a user, cookie expires after
                two hours.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            style={{
              border: "solid #DEE2E6 1.0pt",
              borderTop: "none",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <span lang="EN-GB">XSRF-TOKEN</span>
            </p>
          </td>
          <td
            valign="top"
            style={{
              borderTop: "none",
              borderLeft: "none",
              borderBottom: "solid #DEE2E6 1.0pt",
              borderRight: "solid #DEE2E6 1.0pt",
              padding: ".75pt .75pt .75pt .75pt"
            }}
          >
            <p className="MsoNormal">
              <span lang="EN-GB">
                This cookie is written to help with site security in preventing
                cross-site request forgery attacks.
              </span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p className="MsoNormal">
      <span lang="EN-GB">
        We do not share the information collected by the cookies with any third
        parties.&nbsp;
        <br />
        <br />
        If you do not want to accept any cookies which are essential to the
        services requested, you may be able to change your browser settings so
        that cookies are not accepted. However, if you block all essential
        cookies then please be aware that you may lose some of the functionality
        of our website and not be able to access all or parts of our website.
        For further information about cookies and how to disable them please go
        to the&nbsp;
        <a
          href="https://ico.org.uk/your-data-matters/online/cookies/"
          target="_blank"
        >
          <b>guidance on cookies</b>
        </a>
        published by the UK Information Commissioner’s Office,&nbsp;
        <a href="https://www.allaboutcookies.org" target="_blank">
          <b>www.allaboutcookies.org</b>
        </a>
        .
      </span>
    </p>
    <p className="MsoNormal">
      <span lang="EN-GB">&nbsp;</span>
    </p>
  </div>

    );
};

export default SmileSection;
